module.exports = __webpack_public_path__ + "img/map.19104c4a.png";